import { useNavigate } from "react-router-dom";
import { TaskExample } from "../../interfaces/Task";
import { Form } from "react-bootstrap";
import parse from 'html-react-parser';
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";

export interface TaskExampleDeleteProps {
    taskExample: TaskExample;
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function TaskExampleDelete(props: TaskExampleDeleteProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = () => {
        const requestOptionsDelete = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/examples/delete/' + props.taskExample._id, requestOptionsDelete)
            .then(response => {
                props.submitCallback(props.taskExample._id);
            })
            .catch(error => {
                navigate('/');
            });
    }

    // Get task name safely
    const taskName = props.taskExample.task ? props.taskExample.task.name : t("Unknown task");

    return(
        <Overlay
            title={t("Delete Task Example")}
            onClose={handleClose}
            actions={[
                { label: t("Cancel"), variant: "secondary", onClick: handleClose },
                { label: t("Delete"), variant: "primary", onClick: handleSubmit }
            ]}
        >
            <div className="admin-delete-taskexample-container">
                <Form.Text id="deleteConfirmationMessage">
                    {parse(t("You are about to delete the task example") + '<strong>' + taskName + '</strong>. ' +
                        t("This action cannot be undone.") + ' ' + t("Are you sure you want to proceed?"))
                    }
                </Form.Text>
            </div>
        </Overlay>
    );
}